// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BindingBanner — sticky top banner, one of several state-specific variants.
 * Matches the visual language of dp-addin__content (compact, 12-13px fonts,
 * subtle borders). Each --variant tunes the colour palette per severity:
 *   match     → green   (calm confirmation)
 *   legacy    → slate   (informational)
 *   protected → amber   (warning, but recoverable by user)
 *   rebind    → orange  (needs attention; destructive-if-ignored)
 *   orphan    → red     (cannot save without action)
 *   error     → grey    (system issue, not the user's fault)
 *   loading   → blue    (transient)
 */

.dp-binding-banner {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.45;
  border-bottom: 1px solid transparent;
}

.dp-binding-banner__row {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.dp-binding-banner__icon {
  flex-shrink: 0;
  font-size: 14px;
  line-height: 1.3;
}

.dp-binding-banner__actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}

.dp-binding-banner__btn {
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
}
.dp-binding-banner__btn:hover { opacity: 0.85; }

.dp-binding-banner__btn--primary {
  background: currentColor;
  /* Filled variant: invert text colour so it stays readable inside the
   * coloured pill. Each variant overrides this below. */
}
.dp-binding-banner__btn--primary span,
.dp-binding-banner__btn--primary { color: inherit; }

.dp-binding-banner__dismiss {
  margin-left: auto;
  background: transparent;
  border: none;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.6;
  color: inherit;
  padding: 0 4px;
}
.dp-binding-banner__dismiss:hover { opacity: 1; }

.dp-binding-banner code {
  background: rgba(0, 0, 0, 0.06);
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 11px;
}

/* Secondary reminder line inside a banner (e.g. the Ctrl+S note). Sits
 * below the main message as its own muted line so it informs without
 * competing with the primary state text. */
.dp-binding-banner__hint {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  opacity: 0.8;
}

/* --- Variants -------------------------------------------------------- */

.dp-binding-banner--loading {
  background: #eff6ff;
  border-bottom-color: #bfdbfe;
  color: #1d4ed8;
}

.dp-binding-banner--match {
  background: #f0fdf4;
  border-bottom-color: #bbf7d0;
  color: #166534;
}
/* Match/legacy variants only render a primary button when there's drift
 * (Reload v{N}). Without these overrides the button inherits currentColor
 * for both background and text — same colour, invisible label. */
.dp-binding-banner--match .dp-binding-banner__btn--primary {
  background: #16a34a;
  color: #fff;
  border-color: #16a34a;
}

.dp-binding-banner--legacy {
  background: #f8fafc;
  border-bottom-color: #e2e8f0;
  color: #475569;
}
.dp-binding-banner--legacy .dp-binding-banner__btn--primary {
  background: #475569;
  color: #fff;
  border-color: #475569;
}

.dp-binding-banner--protected {
  background: #fefce8;
  border-bottom-color: #fde68a;
  color: #92400e;
}

.dp-binding-banner--rebind {
  background: #fff7ed;
  border-bottom-color: #fed7aa;
  color: #9a3412;
}
.dp-binding-banner--rebind .dp-binding-banner__btn--primary {
  background: #ea580c;
  color: #fff;
  border-color: #ea580c;
}

.dp-binding-banner--orphan {
  background: #fef2f2;
  border-bottom-color: #fecaca;
  color: #991b1b;
}
.dp-binding-banner--orphan .dp-binding-banner__btn--primary {
  background: #dc2626;
  color: #fff;
  border-color: #dc2626;
}

.dp-binding-banner--error {
  background: #f8fafc;
  border-bottom-color: #cbd5e1;
  color: #475569;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/BindingBanner.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA,gCAAgC,aAAa,EAAE;;AAE/C;EACE,wBAAwB;EACxB;wDACsD;AACxD;AACA;mCACmC,cAAc,EAAE;;AAEnD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA,oCAAoC,UAAU,EAAE;;AAEhD;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;2CAE2C;AAC3C;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,0EAA0E;;AAE1E;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;AACA;;iEAEiE;AACjE;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB","sourcesContent":["/* BindingBanner — sticky top banner, one of several state-specific variants.\n * Matches the visual language of dp-addin__content (compact, 12-13px fonts,\n * subtle borders). Each --variant tunes the colour palette per severity:\n *   match     → green   (calm confirmation)\n *   legacy    → slate   (informational)\n *   protected → amber   (warning, but recoverable by user)\n *   rebind    → orange  (needs attention; destructive-if-ignored)\n *   orphan    → red     (cannot save without action)\n *   error     → grey    (system issue, not the user's fault)\n *   loading   → blue    (transient)\n */\n\n.dp-binding-banner {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  line-height: 1.45;\n  border-bottom: 1px solid transparent;\n}\n\n.dp-binding-banner__row {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.dp-binding-banner__icon {\n  flex-shrink: 0;\n  font-size: 14px;\n  line-height: 1.3;\n}\n\n.dp-binding-banner__actions {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.dp-binding-banner__btn {\n  border: 1px solid currentColor;\n  background: transparent;\n  color: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.dp-binding-banner__btn:hover { opacity: 0.85; }\n\n.dp-binding-banner__btn--primary {\n  background: currentColor;\n  /* Filled variant: invert text colour so it stays readable inside the\n   * coloured pill. Each variant overrides this below. */\n}\n.dp-binding-banner__btn--primary span,\n.dp-binding-banner__btn--primary { color: inherit; }\n\n.dp-binding-banner__dismiss {\n  margin-left: auto;\n  background: transparent;\n  border: none;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.6;\n  color: inherit;\n  padding: 0 4px;\n}\n.dp-binding-banner__dismiss:hover { opacity: 1; }\n\n.dp-binding-banner code {\n  background: rgba(0, 0, 0, 0.06);\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-size: 11px;\n}\n\n/* Secondary reminder line inside a banner (e.g. the Ctrl+S note). Sits\n * below the main message as its own muted line so it informs without\n * competing with the primary state text. */\n.dp-binding-banner__hint {\n  display: block;\n  margin-top: 3px;\n  font-size: 11px;\n  opacity: 0.8;\n}\n\n/* --- Variants -------------------------------------------------------- */\n\n.dp-binding-banner--loading {\n  background: #eff6ff;\n  border-bottom-color: #bfdbfe;\n  color: #1d4ed8;\n}\n\n.dp-binding-banner--match {\n  background: #f0fdf4;\n  border-bottom-color: #bbf7d0;\n  color: #166534;\n}\n/* Match/legacy variants only render a primary button when there's drift\n * (Reload v{N}). Without these overrides the button inherits currentColor\n * for both background and text — same colour, invisible label. */\n.dp-binding-banner--match .dp-binding-banner__btn--primary {\n  background: #16a34a;\n  color: #fff;\n  border-color: #16a34a;\n}\n\n.dp-binding-banner--legacy {\n  background: #f8fafc;\n  border-bottom-color: #e2e8f0;\n  color: #475569;\n}\n.dp-binding-banner--legacy .dp-binding-banner__btn--primary {\n  background: #475569;\n  color: #fff;\n  border-color: #475569;\n}\n\n.dp-binding-banner--protected {\n  background: #fefce8;\n  border-bottom-color: #fde68a;\n  color: #92400e;\n}\n\n.dp-binding-banner--rebind {\n  background: #fff7ed;\n  border-bottom-color: #fed7aa;\n  color: #9a3412;\n}\n.dp-binding-banner--rebind .dp-binding-banner__btn--primary {\n  background: #ea580c;\n  color: #fff;\n  border-color: #ea580c;\n}\n\n.dp-binding-banner--orphan {\n  background: #fef2f2;\n  border-bottom-color: #fecaca;\n  color: #991b1b;\n}\n.dp-binding-banner--orphan .dp-binding-banner__btn--primary {\n  background: #dc2626;\n  color: #fff;\n  border-color: #dc2626;\n}\n\n.dp-binding-banner--error {\n  background: #f8fafc;\n  border-bottom-color: #cbd5e1;\n  color: #475569;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
